import React, { useState } from 'react'
import { HiOutlineLockClosed } from 'react-icons/hi'
import { kioskLogin, kioskLogout } from '../../../services/KioskAuthService'

// There's no dedicated "verify this kiosk secret" endpoint, so the secret is
// checked by attempting a real login with it — a successful login IS proof the
// secret is correct. The session that login creates is immediately torn down
// again via kioskLogout() right after, so this never leaves the kiosk logged
// in under a fresh session by accident.
const KioskLogoutDialog = ({ open, onClose, onLoggedOut, kioskCode }) => {
    const [secret, setSecret] = useState('')
    const [error, setError] = useState('')
    const [verifying, setVerifying] = useState(false)

    if (!open) {
        return null
    }

    const handleClose = () => {
        setSecret('')
        setError('')
        onClose()
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setVerifying(true)
        setError('')

        const result = await kioskLogin({ kioskCode, secret })

        if (result.error) {
            setError('Incorrect kiosk secret.')
            setVerifying(false)
            return
        }

        await kioskLogout()
        setSecret('')
        setVerifying(false)
        onLoggedOut()
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50 px-6">
            <div className="bg-white border border-gray-200 rounded-2xl w-full max-w-sm p-8">
                <div className="flex items-center gap-2 mb-1">
                    <HiOutlineLockClosed className="text-gray-400" />
                    <h2 className="text-base font-medium text-gray-900">Confirm Kiosk Secret</h2>
                </div>
                <p className="text-sm text-gray-400 mb-5">Enter this kiosk's secret to log it out of {kioskCode}.</p>

                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        value={secret}
                        onChange={(e) => setSecret(e.target.value)}
                        placeholder="Kiosk Secret"
                        autoFocus
                        required
                        className="input-field text-lg py-3"
                    />

                    {error && <p className="text-red-600 text-sm mt-2">{error}</p>}

                    <div className="flex justify-end gap-2 mt-5">
                        <button type="button" onClick={handleClose} className="btn-secondary rounded-xl px-4 py-3">
                            Cancel
                        </button>
                        <button type="submit" disabled={verifying} className="btn-primary rounded-xl px-4 py-3">
                            {verifying ? 'Verifying...' : 'Log Out Kiosk'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default KioskLogoutDialog
